var plugin_rtlignore_default = {
  "alignLeft": "_0LjIU",
  "textWrapNowrap": "ZyEoH",
  "alignRight": "yj7pV",
  "alignCenter": "EoX5J",
  "sizeFullWidth": "JGpSh",
  "renderedInTable": "l1Clv",
  "sizeOriginal": "zwvFT",
  "sizeContent": "z37L4",
  "sizeSmall": "uF-jL",
  "sizeSmallCenter": "EX4pB",
  "flex": "b4hyz",
  "atomic": "jYDQj",
  "embed": "N6ju7",
  "horizontalScrollbar": "bH2JY",
  "pluginContainerMobile": "_15GYu"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
